var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C9.48336 0.5 10.9334 0.939868 12.1668 1.76398C13.4001 2.58809 14.3614 3.75943 14.9291 5.12987C15.4968 6.50032 15.6453 8.00832 15.3559 9.46318C15.0665 10.918 14.3522 12.2544 13.3033 13.3033C12.2544 14.3522 10.918 15.0665 9.46318 15.3559C8.00832 15.6453 6.50032 15.4968 5.12987 14.9291C3.75943 14.3614 2.58809 13.4001 1.76398 12.1668C0.939867 10.9334 0.5 9.48336 0.5 8",
    stroke: "#848D27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M8 15.5C6.51664 15.5 5.06659 15.0601 3.83322 14.236C2.59985 13.4119 1.63856 12.2406 1.0709 10.8701C0.503246 9.49968 0.354721 7.99168 0.64411 6.53682C0.9335 5.08197 1.64781 3.74559 2.6967 2.6967C3.74559 1.64781 5.08197 0.9335 6.53682 0.64411C7.99168 0.354721 9.49968 0.503246 10.8701 1.0709C12.2406 1.63856 13.4119 2.59985 14.236 3.83322C15.0601 5.06659 15.5 6.51664 15.5 8",
    stroke: "#848D27"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.6cdc36e225a6706d3467871d7d12f46d.svg";
export { ForwardRef as ReactComponent };